import React, { useEffect, useState, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { BusinessStatusCssClasses } from "../BusinessesUIHelpers";
import * as actions from "../../../_redux/businesses/businessesActions";
import { useBusinessesUIContext } from "../BusinessesUIContext";

const selectedBusinesses = (entities, ids) => {
  const _businesses = [];
  ids.forEach((id) => {
    const business = entities.find((el) => el.id === id);
    if (business) {
      _businesses.push(business);
    }
  });
  return _businesses;
};

export function BusinessesUpdateStatusDialog({ show, onHide }) {
  // Businesses UI Context
  const businessesUIContext = useBusinessesUIContext();
  const businessesUIProps = useMemo(() => {
    return {
      ids: businessesUIContext.ids,
      setIds: businessesUIContext.setIds,
      queryParams: businessesUIContext.queryParams,
    };
  }, [businessesUIContext]);

  // Businesses Redux state
  const { businesses, isLoading } = useSelector(
    (state) => ({
      businesses: selectedBusinesses(state.businesses.entities, businessesUIProps.ids),
      isLoading: state.businesses.actionsLoading,
    }),
    shallowEqual
  );

  // if there weren't selected businesses we should close modal
  useEffect(() => {
    if (!businessesUIProps.ids || businessesUIProps.ids.length === 0) {
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [businessesUIProps.ids]);

  const [status, setStatus] = useState("approved");
  const [message, setMessage] = useState("");
  
  const dispatch = useDispatch();
  const updateStatus = () => {
    // server request for updateing business by ids
    dispatch(actions.updateBusinessesStatus(businessesUIProps.ids, status, message, false)).then(
      () => {
        // refresh list after deletion
        dispatch(actions.fetchBusinesses(businessesUIProps.queryParams)).then(
          () => {
            // clear selections list
            businessesUIProps.setIds([]);
            // closing delete modal
            onHide();
          }
        );
      }
    );
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      aria-labelledby="business-status-modal-title"
    >
      <Modal.Header closeButton className="py-4 px-6">
        <Modal.Title id="business-status-modal-title" className="font-weight-bolder text-dark">
          Update Status for Selected Businesses
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="py-4 px-6">
        <div className="alert alert-custom alert-light-primary fade show mb-4 py-3 px-4 d-flex align-items-center" role="alert">
          <div className="alert-icon mr-3">
            <i className="fa fa-info-circle text-primary font-size-h5"></i>
          </div>
          <div className="alert-text font-size-sm text-dark font-weight-bold">
            Updating status for <span className="text-primary font-size-lg font-weight-bolder">{businessesUIProps.ids.length}</span> selected businesses.
          </div>
        </div>

        <div className="form-group mb-3">
          <label className="font-weight-bold text-dark font-size-sm mb-2">
            Change Status To
          </label>
          <select
            className="form-control"
            value={status}
            onChange={(e) => setStatus(e.target.value)}
          >
            <option value="approved">Approved</option>
            <option value="pending">Pending</option>
            <option value="rejected">Rejected</option>
            <option value="moreinfo">More Info</option>
            <option value="draft">Draft</option>
          </select>
        </div>

        <div className="form-group mb-2">
          <label className="font-weight-bold text-dark font-size-sm mb-2">
            Custom Notification Message (Optional)
          </label>
          <textarea
            className="form-control"
            rows="3"
            placeholder="Type a custom message to send to the business owner(s) via email..."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
        </div>
      </Modal.Body>
      <Modal.Footer className="py-3 px-6">
        <button
          type="button"
          onClick={onHide}
          className="btn btn-light font-weight-bold"
          disabled={isLoading}
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={updateStatus}
          className="btn btn-primary font-weight-bold"
          disabled={isLoading}
        >
          {isLoading ? (
            <>
              <i className="fa fa-circle-notch fa-spin mr-1"></i> Updating...
            </>
          ) : (
            "Update Status"
          )}
        </button>
      </Modal.Footer>
    </Modal>
  );
}
